import React, { useState } from 'react';

const AulaRegistro = (props) => {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [error, setError] = useState('');
    const from = (props.location.state && props.location.state.from) || '/aula';

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        fetch('/aula/auth/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify({ nombre, email, contrasena })
        }).then(async (res) => {
            if (res.status === 200) {
                props.history.push({ pathname: '/aula/confirmar', state: { email, from } });
            } else {
                setError('No se pudo crear la cuenta. Puede que el email ya esté registrado.');
            }
        });
    };

    return (
        <div className="container vh-100 text-center">
            <h3 className="title">Crear cuenta en el Aula Virtual</h3>
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Nombre" value={nombre}
                                onChange={(e) => setNombre(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder="Email" value={email}
                                onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" placeholder="Contraseña" value={contrasena}
                                onChange={(e) => setContrasena(e.target.value)} required minLength={8} />
                        </div>
                        <button type="submit" className="btn aula-btn-primary btn-block">Registrarme</button>
                        {error && <span className="d-block text-danger mt-2">{error}</span>}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AulaRegistro;
